<template>
    <div id="root">
  <div id="app" class="logged-in">
    <div id="app-menu" :class="isModalFirstTime == true ||showNameDialog == true || isModalVisible == true || isModalKharid == true || isModalUpdate == true || isModalInstagram == true? 'custom':''">
      <div id="app-menu-content-wrapper">
        <div id="app-menu-content">
          <div style="margin-bottom: 40px;background-color: #6153cc;border-bottom-right-radius: 30px;border-bottom-left-radius: 30px;height:220px;width:100vw;margin-right: -20px !important;margin-top: -30px;" id="app-menu-content-header">
            <div style="margin-top:10px;padding: 20px;" class="app-menu-content-header-section">
              <div id="app-menu-info" class="info">

              </div>
              <div style="" class="reminder">
                <div class="reminder-icon">
                  <img style="height: 60px;width:60px;" :src="require('@/assets/img/bot.png')"/>
                </div>
                <span style="margin-right:10px;font-size: 20px;" class="reminder-text">سلام {{ name }}!
                </span>
              </div>
              <div class="reminder">
              <span style="margin-right:10px;font-size: 20px;font-weight: bold;color: white;" class="reminder-text">چطور میتونم کمکت کنم؟
                </span>
                </div>
                
                <div style="margin-top: 30px;" @click="gotoChat()" class="reminder">
                    <span style="background: #212529;width:85vw;padding: 10px;margin-right:10px;font-size: 20px;font-weight: bold;color: rgb(207, 207, 207);border-radius: 10px;" class="reminder-text">سوالت رو اینجا بنویس...
                </span>
                </div>
            </div>
            
          </div>
          <div v-if="conversations.length != 0" id="weather-section" class="menu-section">
            <div style="display:flex;justify-content:space-between"><div class="menu-section-title">
                <i class="fa-solid fa-envelope" aria-hidden="true"></i>
              <span class="menu-section-title-text" >آخرین گفتگو ها</span>
            </div>
            <div class="menu-section-title">
              <span @click="gotoConversations()" class="menu-section-title-text text-button2" style="padding:10px;border-radius:10px;font-weight:200;font-size:1.0em">مشاهده  همه</span>
            </div>
        </div>
            <div class="scrollable-component menu-section-content">
                <div v-for="(item,index) in conversations" :key="index" style="width:60vw;height:50px;" @click="gotoChat(item.id)" class="quick-nav-item text-button">
              <span class="overflow" style="display:block;padding:7px;font-size:17px;font-family: IRANSansWeb;color:white">{{ item.title }}</span>
            </div>
        </div>
          </div>
        <div id="tools-section" class="menu-section">
            <div class="menu-section-title">
              <i class="fa-solid fa-lightbulb" aria-hidden="true"></i>
              <span class="menu-section-title-text">موضوعات پیشنهادی</span>
            </div>
            <div class="scrollable-component menu-section-content" style="height: 100%;">
              <div  @click="categorys(1)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/music.png') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >موزیک</span>
                  </div>
                </div>
              </div>
              <div  @click="categorys(2)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/health.png') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >سلامتی</span>
                  </div>
                </div>
              </div>
              <div  @click="categorys(3)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/marketing.png') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >مارکتینگ</span>
                  </div>
                </div>
              </div>
              <div  @click="categorys(4)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/cooking.jpg') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >آشپزی</span>
                  </div>
                </div>
              </div>
              <div  @click="categorys(5)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/chatgpt.jpg') + ')' }"></div>
                <div class="tool-card-content">
                  
                </div>
              </div>
              <div  @click="categorys(6)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/content.jpg') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >محتوا</span>
                  </div>
                </div>
              </div>
              <div  @click="categorys(7)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/bussiness.jpg') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >کسب و کار</span>
                  </div>
                </div>
              </div>
              <div  @click="categorys(8)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/learning.jpg') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >آموزش</span>
                  </div>
                </div>
              </div>
              <div  @click="categorys(9)" class="tool-card quick-nav-item">
                <div class="tool-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/categorys/programming.jpg') + ')' }"></div>
                <div class="tool-card-content">
                  <div class="tool-card-content-header">
                    <span class="tool-card-name" >برنامه نویسی</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scrollable-component menu-section-content">
                <div v-for="(item,index) in texts" :key="index" style="width:90vw;height:50px;margin-top: 15px;" @click="gotoChatWithSuggestion(item.text)" class="quick-nav-item text-button">
              <span class="overflow2" style="display:block;padding:7px;font-size:14px;font-family: IRANSansWeb;color:white">{{ item.title }}
                

            </span>
            <i style="position: absolute;left: 0;top: 50%;transform: translateY(-50%);padding: 10px 15px;color:white" class="fa-solid fa-angles-left"></i>
            </div>
            </div>

          <div id="movies-section" class="menu-section">
            <div class="menu-section-title">
              <span class="menu-section-title-text">امکانات دیگر...</span>
            </div>
            <div class="scrollable-component menu-section-content">
              <div @click="gotoImageGeneration()" id="movie-card-2" class="movie-card">
                <div class="movie-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/adobe.jpeg') + ')' }"></div>
                <div class="movie-card-content">
                  <div class="movie-card-info">
                    <span class="movie-card-title">ساخت عکس</span>
                    <span class="movie-card-desc">ایجاد تصاویر متنوع و جذاب را با روبو پیکاسو تجربه کنید.</span>
                  </div>
                  <i class="fa-solid fa-hat-wizard" aria-hidden="true"></i>
                </div>
              </div>
              <div @click="gotoCharacters()" id="movie-card-1" class="movie-card">
                <div class="movie-card-background background-image" :style="{ backgroundImage: 'url(' + require('@/assets/img/characters.png') + ')' }"></div>
                <div class="movie-card-content">
                  <div class="movie-card-info">
                    <span class="movie-card-title">شخصیت های مختلف</span>
                    <span class="movie-card-desc">برای اولین بار قابلیت گفتگو با شخصیت های مختلف را با روبو تجربه کنید.
              <br>
              مانند: روان شناس, برنامه نویس, معلم, مترجم و ...</span>
                  </div>
                  <i class="fa-solid fa-users"></i>
                                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isModalVisible" class="login-box">
        <div class="basket" style="padding:10px;"><div style="padding:20px;" :class="this.kharid == 0? 'purchaseSuccess':'purchaseFail'" class="rounded-2 bg-cff6e9 position-relative">
            <h5 style="font-weight: bold;font-size: 15px;" class="mb-4 title fw-bold pt-2">{{this.kharid == 0 ? 'خرید انجام شد!':'خرید انجام نشد!'}}</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: center;" class="font-12 pb-4 text">{{ this.name }} عزیز<br>{{this.kharidText}}</p>
                <button @click="this.isModalVisible = false" type="submit" class="text-white btn btn-primary " style="margin-bottom:10px;right:35%;position: relative">بستن</button>
    </div><!----><!----></div>
    </div>
    <div v-if="isModalFirstTime" class="login-box">
        <i @click="isModalFirstTime = false" class="fa-solid fa-x" style="padding: 5px; color:white"></i>
        <div style="padding:5px;margin-top: 15px;display: grid;">
            <span style="font-size:20px;font-weight: bold;color:white"><i class="fa-solid fa-gift" style="font-size:20px;color:#6153cc"></i> کوکی روزانه</span>
            <span style="padding:5px;margin-top:5px;font-size:15px;color:white">شما میتوانید از تمامی امکانات روبو به طور رایگان و تا 5 کوکی که به طور روزانه دریافت میکنید استفاده نمایید. درصورتی که به کوکی🍪 بیشتری نیاز داشته باشید میتوانید با تهیه بسته های کوکی🍪 از مزایای ویژه آن استفاده کنید.</span>
            <hr>
            <span style="font-size:20px;font-weight: bold;color:white"><i class="fa-solid fa-image" style="font-size:20px;color:#6153cc"></i> خلق عکس با روبو پیکاسو</span>
            <span style="padding:5px;margin-top:5px;font-size:15px;color:white">امکان ایجاد عکس مبتنی بر هوش مصنوعی در بخش عکس فراهم می باشدو در بخش گفتگو، فقط گفتگوی متنی با روبو امکان پذیر است.</span>
            <hr>
            <span style="font-size:20px;font-weight: bold;color:white"><i class="fa-solid fa-info-circle" style="font-size:20px;color:#6153cc"></i> صحت و دقت اطلاعات</span>
            <span style="padding:5px;margin-top:5px;font-size:15px;color:white">برنامه روبو بعنوان سرویس واسط از محبوب ترین هوش مصنوعی های دنیا از جمله ChatGPT، برای کاربران ایرانی با امکانات کاربردی و پیشرفته تری ساخته شده و صحت و دقت جواب های متنی و تصاویر ایجاد شده را طبق شرایط و قوانین برنامه، تایید یا رد نمی کند.</span>
            <div @click="this.isModalFirstTime = false" style="display: flex;justify-content: end;margin-top: 10px;margin-bottom: 10px;text-align: center;">
            <div style="padding:10px;border-radius: 5px;background-color: #6153cc;width:90px;color:white;font-weight: bold;font-size:12px">متوجه شدم</div>
          </div>
          </div>
    </div>
    <div v-if="isModalInstagram" class="login-box">
        <i @click="isModalInstagram = false" class="fa-solid fa-x" style="padding: 5px; color:white"></i>
        <div style="padding:5px;margin-top: 15px;display: grid;">
            <span style="font-size:20px;font-weight: bold;color:white"><i class="fa-solid fa-gift" style="font-size:20px;color:#6153cc"></i> اینستاگرام روبو</span>
            <span style="padding:5px;margin-top:5px;font-size:15px;color:white;line-height: 25px;">برای دریافت اخبار، آموزش، کد تخفیف و ... اینستاگرام روبو را دنبال کنید و 20 کوکی🍪 هدیه بگیرید. </span>
            <div @click="this.isModalFirstTime = false" style="display: flex;justify-content: space-between;margin-top: 10px;margin-bottom: 10px;text-align: center;">
              <div @click="goFollow()" style="padding:10px;border-radius: 5px;background-color: #6153cc;color:white;font-weight: bold;font-size:14px">دنبال کردن و دریافت 20 کوکی🍪</div>
            <div @click="dontShowInstagram()" style="padding:10px;border-radius: 5px;background-color: #f01111;width:90px;color:white;font-weight: bold;font-size:14px">بیخیال</div>
          </div>
          </div>
    </div>
    <div v-if="isModalUpdate" style="z-index:100000" class="login-box">
        <i @click="isModalUpdate = false" class="fa-solid fa-x" style="padding: 5px; color:white"></i>
        <div style="margin-top: 15px;display: grid;">
            <span style="font-size:20px;font-weight: bold;color:white"><i class="fa-solid fa-download" style="font-size:20px;color:#6153cc"></i> بروزرسانی</span>
            <span style="padding:5px;margin-top:5px;font-size:15px;color:white">برای استفاده از تمامی امکانات روبو لطفا برنامه خود را بروزرسانی کنید.</span>
            <div style="display: flex;justify-content: space-between;margin-top: 10px;margin-bottom: 10px;text-align: center;">
            <div @click="goUpdate()" style="padding:10px;border-radius: 5px;background-color: #6153cc;width:90px;color:white;font-weight: bold;font-size:12px">بروزرسانی</div>
            <div @click="dontShowAgain()" style="padding:10px;border-radius: 5px;background-color: #6153cc;width:90px;color:white;font-weight: bold;font-size:12px">نشان نده</div>
          </div>
          </div>
    </div>
  <div v-if="showNameDialog" class="login-box">
    <div class="basket"><div style="overflow: auto;
max-height: 70vh;" class="nameSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
         <h5 class="mb-4 title fw-bold pt-2" style="font-weight: bold;font-size: 15px;">انتخاب اسم</h5>
        <p style="white-space: pre-line;
  padding: 0;
  color: #fff;
  text-align: center;" class="font-12 text">برای ادامه  یک اسم برای خود انتخاب کنید.</p>
  <div class="user-box" style="margin-top:30px;">
      <input v-model="chosenName" class="p-inputtext p-component p-invalid" style="text-align: start; unicode-bidi: plaintext;" type="text" name="" required="" >
      <label>اسم شما</label>
    </div>
    <div v-if="isGoogleAccount && isFirstTime" class="form-group form-check"  style="margin-top:20px;">
    <input v-model="showReferralBox" type="checkbox" id="referralCheck" class="form-check-input">
    <label class="form-check-label" for="referralCheck" style="font-size:12px;color: white;">در صورتی که کد معرف دارید این گزینه را فعال کنید (نیازی به پر کردن نیست)</label>
 </div>
 <div v-if="showReferralBox" class="user-box" style="margin-top:30px;">
      <input v-on:keydown.enter.prevent="sendVerificationCode()" v-model="referral" enterkeyhint="done" style="text-align: right;" type="text" maxlength="6" name="" required>
      <label>کد معرف</label>
    </div>
   <button type="submit" @click="updateName()" class="text-white btn btn-primary w-100" style="margin-top:20px;margin-bottom: 7px;">همین خوبه!
   </button>
</div> </div>
  </div>
  <br/>
  <br/>
  <br/>
</div>
</template>
<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
  export default {
    name: 'App',
  
    data() {
      return {
        isModalVisible:false,
        showNameDialog:false,
        isModalFirstTime:false,
        showReferralBox:false,
        referral:"",
        name:"",
        credit:0,
        isModalUpdate:false,
        isGoogleAccount:false,
        isFirstTime:false,
        isModalInstagram:true,
        isRewarded:false,
        timeElapsed:0,
        pageStatus:false,
        mobile:null,
        chosenName:"",
        isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
        isNewUpdate: navigator.userAgent.match(/NewUpdate/i) ? true : false,
        kharid:0,
        kharidText:'از اینکه به ما اعتماد کردید سپاس‌گزاریم. امیدواریم از خریدتان راضی باشید.',
        texts:[],
        inputText:"",
        conversations:[
           
        ]
      };
    },
    methods:{
       visChange(event) {
        var that = this;

  if (document.hidden && !that.pageStatus) {
    that.timeElapsed = 0
  var intId = setInterval(function () { 
  console.log(that.timeElapsed);
  if(that.pageStatus == true)
  that.timeElapsed += 1;
  else
  clearInterval(intId);
  if(that.timeElapsed > 8)
  clearInterval(intId);
}, 1000);
  }
  else if (!document.hidden && that.pageStatus) {
  if(that.timeElapsed >= 8)
  {
    const config = { headers: {'Content-Type': 'application/json'} };
      axios.post("https://localhost:44389/api/Users/AddInstagramGift",localStorage.getItem("token"),config).then(response=>{
        if(response.data == "0")
            {
              that.isModalInstagram = false;
              that.userInfo.credit = that.userInfo.credit +20;
              that.$emit("setCredit");
    notify({
  title: "تبریک!",
  text: "20 کوکی🍪 به شما اضافه شد",
  type: "success"
});
localStorage.setItem("showInstagram",new Date());
document.removeEventListener('visibilitychange',this.visChange);
            }
            else
            {
              that.isModalInstagram = false;
              notify({
  title: "ناموفق!",
  text: "شما قبلا این هدیه را دریافت کردید!",
  type: "error"
});
localStorage.setItem("showInstagram",new Date());
document.removeEventListener('visibilitychange',this.visChange);
            }
      });
    
  }
  else
  notify({
  title: "ناموفق",
  text: "برای دریافت هدیه لطفا اینستاگرام روبو را دنبال کنید",
  type: "error"
});
  }
  that.pageStatus = document.hidden;
},
      goFollow()
      {
        if(this.isApplication == true)
      Android.Download("instagram://user?username=roboo.ir");
      else
      window.open("https://www.instagram.com/roboo.ir");
      document.removeEventListener('visibilitychange',this.visChange);

      
 document.addEventListener('visibilitychange', this.visChange);
      },
      dontShowInstagram()
      {
        localStorage.setItem("showInstagram",new Date());
        this.isModalInstagram = false;
      },
      dontShowAgain()
      {
        localStorage.setItem("showUpdate","true");
        this.isModalUpdate = false;
      },
      goUpdate()
      {
        if(this.$route.query.utm_campaign != null)
        {
          if(this.$route.query.utm_campaign == "myket")
          {
            Android.Download("myket://download/ir.roboo.pwa")
          }
          else if(this.$route.query.utm_campaign == "bazaar")
          {
            Android.Download("bazaar://details?id=ir.roboo.pwa")
          }
        }
        else
        {
           Android.Download("https://roboo.ir")
        }
        
      },
      gotoConversations()
        {
          router.push("/conversations");
        },
        gotoImageGeneration()
        {
          router.push("imagegeneration");
        },
        gotoCharacters()
        {
          router.push("/characters");
        },
      gotoChatWithSuggestion(suggest)
      {
        localStorage.setItem("character","chat");
        localStorage.setItem("selectedSuggestion",suggest);
        localStorage.setItem("conversationId","");
        router.push("/chat");
      },
        gotoChat(id)
        {
          if(id == undefined)
          id="";
          localStorage.setItem("conversationId",id);
          router.push("/chat");
        },
        getuserData()
        {
            //this.chats=[];
        this.history=[];
             axios.get("https://api3.roboo.ir/api/Users/GetUserDataC?token="+localStorage.getItem("token"))
        .then(response=>{
            if(response.data.status == 0)
            {
                this.mobile = response.data.mobile;
                this.credit = response.data.credit;
                this.userInfo.credit = this.credit == 0?response.data.freeCredit:this.credit;
                this.$emit("setCredit");
                this.name = response.data.name;
                localStorage.setItem("userName",this.name);
                this.conversations = response.data.conversations;
                if(this.name == "")
                {
                  this.showNameDialog = true;
                }
                this.engheza = response.data.packageEndDate;
                this.invites = response.data.referrals;
                this.Referral = response.data.referral;    
            }
            else
            {
                //NotSuccess
                router.push("login");
            }
        }).catch(function(error) {
            console.log(error);
            console.log(error.code);
  if (!error.response) {
    router.push("/game");
    // network error (server is down or no internet)
  } else {
    // http status code
    console.log(error.response.status)
    // data from server while error
    console.log(error.response.data)
  }});
        },
        updateName()
   {
      let json = {
         token : localStorage.getItem("token"),
         name: this.chosenName
      }
      axios.post("https://api3.roboo.ir/api/users/ChosenName",json)
      .then(response => {
         console.log(response.data);
         if(response.data == 0)
         {
          this.showNameDialog = false;
            this.name = this.chosenName;
            localStorage.setItem("userName",this.name);
            this.isModalFirstTime = true;
         }
         else
         {
            this.showNameDialog = true;
         }
      });
      if(this.isFirstTime && this.isGoogleAccount)
      {
        let json2 = {
         token : localStorage.getItem("googleAccount"),
         referral: this.referral
      }
      axios.post("https://api4.roboo.ir/api/users/SetReferralForGoogleAccount",json2)
      .then(response => {
         console.log(response.data);
         if(response.data == 0)
         {
           //Payam Tabrik Davat
         }
         else
         {
            
         }
      });
      }
   },
        categorys(id)
    {
        if(id == 0)
        {
            this.texts=[];
            this.texts.push({title:"ساخت موزیک ویدیو با مفهوم",text:"می خواهم یک موزیک ویدیو بسازم اما نمی دانم از چه مفهومی استفاده کنم. منو راهنمایی کن"});
            this.texts.push({title:"ساخت آکورد و کلید ها",text:"یک پشروی آکورد بلوز 12 نواری در کلید E بنویسید"});
            this.texts.push({title:"پیدا کردن متن آهنگ دلخواه",text:"متن آهنگی با عنوان [عنوان آهنگ] را بنویس"});
            this.texts.push({title:"ساخت شعر با موضوع انتخابی",text:"یک شعر یا آهنگ برای <مخاطب هدف> ایجاد کنید که <موضوع انتخلبی شما> را توضیح دهد"});
        }
        if(id == 1)
        {
            this.texts=[];
            this.texts.push({title:"ساخت موزیک ویدیو با مفهوم",text:"می خواهم یک موزیک ویدیو بسازم اما نمی دانم از چه مفهومی استفاده کنم. منو راهنمایی کن"});;
            this.texts.push({title:"ساخت آکورد و کلید ها برای 12 نوازی",text:"یک پشروی آکورد بلوز 12 نواری در کلید E بنویسید"});;
            this.texts.push({title:"پیدا کردن متن آهنگ انتخابی",text:"متن آهنگی با عنوان [عنوان آهنگ] را بنویس"});;
            this.texts.push({title:"ساخت شعر با موضوع انتخابی",text:"یک شعر یا آهنگ برای <مخاطب هدف> ایجاد کنید که <موضوع انتخلبی شما> را توضیح دهد"});;
            this.texts.push({title:"تغییر آکورد آهنگ با سبک",text:"پیشرفت آکورد زیر را تغییر دهید تا بیشتر شبیه <بر اساس برخی دستورات, مانند آهنگساز یا سبک> باشد"});;
            this.texts.push({title:"متن شعر مرغ سحر شجریان",text:"متن شعر مرغ سحر ناله سر کن شجریان رو بنویس"});;
            this.texts.push({title:"کد پایتون برای فایل midi",text:"من می خواهم یک فایل midi بنویسم. میشه کد python رو بزارید"});;
            this.texts.push({title:"ساخت آهنگ 4/4 برای هنرمند انتخابی",text:"یک آهنگ در مقیاس پنتاتونیک و 4/4 زمان برای <هنرمند مورد نظر خود> بنویس"});;
            this.texts.push({title:"مشاعره بین حافط و مولانا",text:"یک مشاعره بین حافظ و مولانا انجام بده"});;
            this.texts.push({title:"پیشرفت آکورد برای آهنگ راک کانتری",text:"پیشرفت های آکورد را برای یک آهنگ راک کانتری, با شعرئکر و بریج بنویسید"});;
        }
        else if(id == 2)
        {
            this.texts=[];
            this.texts.push({title:"راه های پرورش ذهنیت رشد",text:"چند راه برای پرورش ذهنیت رشد چیست؟"});;
            this.texts.push({title:"وعده غذایی مغذی زیر نیم ساعت",text:"4 وعده غذایی مغذی را در نظر بگیرید که می توانید در عرض نیم ساعت یا کمتر تهیه کنید"});;
            this.texts.push({title:"تمرین های کاهش اضطراب",text:"چند تمرین ذهن آگاهی برای کاهش اضطراب چیست؟"});;
            this.texts.push({title:"راهکار های با انگیزه ماندن در کار",text:"من به کمک نیاز دارم تا در کار با انگیزه بمانم. می توانی به من چند راهکار بدی؟"});;
            this.texts.push({title:"فعالیت های خود مراقبتی برای کاهش استرس",text:"چند تا فعالیت خود مراقبتی را برای کاهش استرس پیشنهاد بده"});;
            this.texts.push({title:"برنامه ورزش 30 روزه برای کاهش وزن",text:"یک برنامه ورزشی 30 روزه ایجاد کنید که به من کمک میکند هر هفته 2 کیلو وزن کم کنم"});;
            this.texts.push({title:"8 ماده غذایی ارزان و مغذی",text:"8 تا ماده غذایی که ارزان باشه و به طرز شگفت انگیزی مغذی باشه رو بهم بگو"});;
            this.texts.push({title:"انگیزه برای هدف شما",text:"برای <دستیابی به یک کار یا هدف خاص> به انگیزه نیاز دارم. میشه بهم انگیزه بدی"});;
            this.texts.push({title:"حرکات کششی یوگا برای کمردرد و گردن",text:"شش حرکت کششی موثر در یوگا را برای کمردرد و گردن توضیح دهید"});;
        }
        else if(id == 3)
        {
            this.texts=[];
            this.texts.push({title:"بک لینک برای بالابردن سئو سایت شما",text:"چگونه میتوانم Back link های با کیفیت برای بالا بردن SEO [نام وب سایت] به دست بیاورم؟"});;
            this.texts.push({title:"طرح کمپین برای محصول",text:"یک طرح کمپین [رسانه های اجتماعی] برای راه اندازی [محصول شما] با هدف [مخاطبان هدف شما] بساز"});;
            this.texts.push({title:"اسکریپت یک دقیقه برای تبلیغ",text:"یک اسکریپت یک دقیقه ای برای تبلیغ درمورد (محصول یا خدمت یا شرکت) بساز"});;
            this.texts.push({title:"پست برای توئیتر که هدف نسل زد باشد",text:"یک پست برای انتشار در توئیتر بساز که نسل زد را هدف قرار دهد و توضیح دهد که چگونه محصول ما [نام محصول] می تواند به آنها کمک کند"});;
            this.texts.push({title:"ایده های ویدیوی YouTube",text:"قهرستی از 5 ایده ویدیوی YouTube برای [محصول یا شرکت شما] تهیه کن"});;
            this.texts.push({title:"ساخت خبرنامه هفتگی",text:"یک خبرنامه هفتگی [موضوع خبرنامه] را بساز"});;
            this.texts.push({title:"ساخت توضیح محصول",text:"یک توضیح محصول برای [محصول یا خدمت یا شرکت] من بنویس"});;
            this.texts.push({title:"ساخت پست اینستاگرام برای محصول",text:"یک پست اینستاگرام بساز که مزایای محصول من رو (نام محصول) پیشنهاد بده"});;
            this.texts.push({title:"روش های خلاقانه برای پست اینستاگرام",text:"5 روش خلاقانه برای استفاده از حلقه های اینستاگرام برای شما ایجاد کنید"});;
            this.texts.push({title:"راه های افزایش فالور اینستاگرام",text:"چطور میتوانم فالور های اینستاگرام افزایش بدم"});;
            this.texts.push({title:"روش های مقرون به صرفه تبلیغ شرکت",text:"روش های مقرون به صرفه برای تبلیغ (شرکت) خود با/بدون استفاده از (شبکه های اجتماعی) پیشنهاد بده"});;
            this.texts.push({title:"نوشتن ایمیل برای شرکت کنندگان وبینار",text:"برای افرادی که در وبینار {موضوع وبینار} من شرکت کرده اند ایمیل های تکمیلی بنویسید"});;
            this.texts.push({title:"نوشتن ایمیل تبریک شخص VIP",text:"یک ایمیل تبریک شخصی برای یک مشتری VIP بنویس"});;
            this.texts.push({title:"ایده های پست وبلاگ",text:"یه ایده هایی برای پست های ولاگ درمورد موضوع (انتخابی) نیاز دارم"});;
            this.texts.push({title:"استراتژی استوری های اینستاگرام",text:"چجوری میتوانم یک استراتژی برای استوری های روزانه در اینستاگرام داشته باشم؟"});;
        }
        else if(id == 4)
        {
            this.texts=[];
            this.texts.push({title:"منوی باحال بهاری",text:"یه منو باحال بهاری بگو؟"});;
            this.texts.push({title:"ایده شام برای گیاهخواران",text:"من گیاهخوار هستم. یه ایده باحال برای شام بهم بده"});;
            this.texts.push({title:"غذای خوب برای کسی که روزه سختی داشته",text:"برای کسی که یه روز سخت داشته یه غذای خوب پیشنهاد بده"});;
            this.texts.push({title:"وعده ناهار وگان با مواد اولیه",text:"من گوجه, کاهو و کلم بروکلی دارم. چه چیزی می توانم با آنها برای یک ناهار وگان آماده کنم؟"});;
            this.texts.push({title:"بک هفته شام دو بزرگسال",text:"برای یک هغته شام دو بزرگسال برنامه ریزی کن که چه غذاهایی بپزم"});;
            this.texts.push({title:"آسان ترین روش تهیه ماکارونی و سس سفید",text:"سریع و آسان ترین راه برای تهیه ماکارونی با سس سفید و قارچ چیست؟"});;
            this.texts.push({title:"3 وعده غذایی با مواد اولیه",text:"من فقط پیاز, گوجه فرنگی و اسفناج دارم. 3 وعده غذایی را به من بگو که با این مواد درست کنم؟"});;
            this.texts.push({title:"برنامه غذایی دو روزه با لیست خرید",text:"یک برنامه غذایی برای دو روز تهیه کنید و لیست خرید آن را به من بدهید"});;
            this.texts.push({title:"غذای جذاب با ماهی برای نوروز",text:"برای نوروز ایرانی, دستور پخت غذای جذاب با ماهی بهم پیشنهاد کن"});;
            this.texts.push({title:"طرز تهیه خورشت قیمه",text:"طرز تهیه خورشت قیمه رو بگو"});;
        }
        else if(id == 5)
        {
            this.texts=[];
            this.texts.push({title:"آیا Chat GPT امن است؟",text:"آیا Chat GPT امن است؟"});;
            this.texts.push({title:"Chat GPT چیست؟",text:"Chat GPT چیست؟"});;
            this.texts.push({title:"نوشتن مقاله با ChatGPT",text:"آیا Chat GPT می تواند یک مقاله بنویسد؟"});;
        }
        else if(id == 6)
        {
            this.texts=[];
            this.texts.push({title:"وبلاگ در مورد موضوع شما",text:"وبلاگ در مورد [موضوع دلخواه شما] بنویسید"});;
            this.texts.push({title:"ساخت داستان علمی تخیلی",text:"یک داستان علمی تخیلی در 200 کلمه بنویس که شخصیت اول اسمش علی باشه و میخواهد دنیا را نجات دهد"});;
            this.texts.push({title:"مطالعه موردی با جزئیات",text:"یک مطالعه موردی با جزئیات <موضوع انتخابی> بنویسید"});;
            this.texts.push({title:"طراحی درس منابع انرژی",text:"یک درس درمورد منابع انرژی تجدید پذیر برای دانش آموزان دبیرستانی طراحی کن"});;
            this.texts.push({title:"راهنمای جامع برای موضوع",text:"یک راهنمای جامع برای [موضوع] بنویسید"});;
        }
        else if(id == 7)
        {
            this.texts=[];
            this.texts.push({title:"عوامل هنگام نقل قول",text:"چه عواملی را باید در هنگام نقل قول برای یک معامله برند در نظر بگیرم؟"});;
            this.texts.push({title:"راهنمایی در شبکه سازی کسب و کار",text:"به عنوان یک صاحب کسب و کار کوچک, درمورد شبکه سازی و ایجاد مشارکت راهنماییم کن"});;
            this.texts.push({title:"روند و چالش های صنعت",text:"درباره <صنعت> و روندها, چالش ها و فرصت های آن, از جمله داده ها و آمار های مربوطه راهنماییم کن"});;
            this.texts.push({title:"راهنمایی ارائه برای سرمایه گذار",text:"من باید یک ارائه برای یک سرمایه گذار بالقوه در مورد <موضوع ارائه> آماده کنم. میشه راهنماییم کنید که چی بزارم؟"});;
            this.texts.push({title:"بررسی دقیق از کسب و کار",text:"یک بررسی دقیق از <نرم افزار یا ابزار خاص> برای <تشریح کسب و کار خود> انجام بده"});;
        }
        else if(id == 8)
        {
            this.texts=[];
            this.texts.push({title:"ساخت رزومه با ویژگی های فردی",text:"من یه معلم هستم. یه فهرست از 10 ویژگی منحصر به فرد را برای درج در رزومه بعنوان یک معلم ریاضی بنویس"});;
            this.texts.push({title:"روش های آموزش کودکان",text:"بهترین روش آموزش کودکان چیست؟"});;
            this.texts.push({title:"روش های بهبود عملکرد دانش آموزان",text:"فهرستی از مراحل مشخص و قابل اجرا که یک دانش آموز باید انجام دهد تا بتواند عملکرد خود را در (موضوع/وظیفه) بهبود بخشد تهیه کن"});;
            this.texts.push({title:"طرح سوال چهار گزینه ای",text:"یه سوال چهار گزینه ای طرح کن که صورت سوال درباره گرم شدن کره زمین باشه"});;
            this.texts.push({title:"مشکلات یادگیری کودکان در حروف صدا دار",text:"کودکان در یادگیری حروف صدا دار چه مشکلاتی دارند؟"});;
            this.texts.push({title:"نوشتن مقاله درمورد تبیض اجتماعی",text:"یک مقاله در مورد تبعیض اجتماعی بنویس که نمره 20 بگیرم"});;
            this.texts.push({title:"مراحل آموزش زبان جدید",text:"برای آموزش یک زبان جدید چه مراحلی باید طی شه؟"});;
            this.texts.push({title:"طرح پوستر برای مقررات و مجازات کلاس",text:"پیشنهاد طراحی یه پوستر بده که دانش آموزان, مقررات کلاس درس و همچنین مجازات را متوجه بشوند"});;
            this.texts.push({title:"فهرست استراتژی آموزشی",text:"فهرستی از 5 استراتژی آموزشی ایجاد کنید که می تواند برای درگیر کردن و به چالش کشیدن دانش آموزان در سطوح مختلف توانایی در یک درس در مورد [مفهوم در حال آموزش] استفاده شود."});;
            this.texts.push({title:"راهکار معلم ها برای یادگیری و پیشرفت دانش آموز",text:"2 راهکار برای معلم ها که بتوانند بر یادگیری و پیشرفت دانش آموزان نظارت کنند پیشنهاد بده"});;
        }
        else if(id == 9)
        {
            this.texts=[];
            this.texts.push({title:"نحوه انجام کار با جاوا اسکریپت",text:"من می خواهم یک هدر چسبنده در وب سایت خود پیاده سازی کنم. آیا می توانید مثالی از نحوه انجام این کار با استفاده از CSS و جاوا اسکریپت ارائه دهید ؟"});;
            this.texts.push({title:"جدول SQL از توییت های ایلان ماسک",text:"نام جدول هارا فرض کنید و یک کد SQL ایجاد کنید تا توییت های ایلان ماسک در سال 2019 را داشته باشد"});;
            this.texts.push({title:"ساخت تابع docstring",text:"یک docstring برای تابع زیر <تابع شما> بنویسید"});;
            this.texts.push({title:"پیدا کردن اشکال کد",text:"اشکال کد زیر را پیدا کن: <کد>"});;
            this.texts.push({title:"ایده های ساختار وب سابت برای کسب و کار",text:"من درحال ساخت یک وب سایت برای یک تجارت کوچک [شرح کسب و کار]. من به ایده هایی درمورد چگونگی ساختار وب سایت نیاز دارم"});;
            this.texts.push({title:"کد Regex من چه کاری انجام میدهد",text:"این regex دقیقا چه کاری انجام میدهد ؟ <کد شما>"});;
            this.texts.push({title:"مثال از React و Next.js",text:"من می خواهم رندر سمت سرور را برای برنامه React خود پیاده سازی کنم. آیا میتوانید مثالی از نحوه انجام این کار با استفاده از Next.js ارائه دهید؟"});;
            this.texts.push({title:"نوشتن کد جاوا اسکریپت",text:"لطفا به نوشتن این کد برای جاوا اسکریپت <کد شما> ادامه دهید"});;
            this.texts.push({title:"نوشتن Rest API برای وب سایت",text:"من باید یک نقطه پایانی  Rest API برای برنامه وب ایجاد کنم"});;
            this.texts.push({title:"نحوه انجام کار با Node.js",text:"آیا میتوانید مثالی از نحوه انجام این کار با استفاده از Node.js ارائه دهید؟"});;
            this.texts.push({title:"نکته طراحی UX برای اشتراک گذاری در Linkedin",text:"یه نکنه طراحی UX ارائه دهید تا بتوانم آن را در Linkedin به اشتراک بگذارم"});;
            this.texts.push({title:"مهارت های استغاده از وردپرس",text:"با استفاده از وردپرس فهرستی از 10 مهارت و تجربه مرتبط را برای یک برنامه شغلی توسعه دهنده وب ایجاد کنید"});;
            this.texts.push({title:"معماری توسعه وب سایت با جاوا اسکریپت",text:"یک معماری توسعه وب سایت با جاوا اسکریپت پیشنهاد بده"});;
        }
    },
    },
    mounted(){
      // if(this.isApplication == true && this.isNewUpdate == false)
      // {
      //   if(localStorage.getItem("showUpdate") == null)
      //   {
      //     this.isModalUpdate = true;
      //   }
      // }
      if(this.$route.query.utm_campaign != null)
        {
          if(this.$route.query.utm_campaign == "myket")
          {
            localStorage.setItem("campaign","myket");
          }
          else if(this.$route.query.utm_campaign == "bazaar")
          {
            localStorage.setItem("campaign","bazaar");
          }
        }
      var elements = document.getElementById("topnav");
      if(elements !=null)
      {
        elements.style.backgroundColor="#6153cc";
        var color = false;
        var that = this;
        var path = this.$route.path;
        const  onScroll =() => {
    const {
        scrollTop,
        scrollHeight,
        clientHeight
    } = document.documentElement;
    if(that.$route.path != path)
    {
      elements.style.backgroundColor="#212529";
      window.removeEventListener('scroll',onScroll);
      return;
    }
    if (scrollTop > 210 && color == false) {
      elements.style.backgroundColor="#212529";
      color=true;
    }
    else if(scrollTop<= 210 && color == true)
    {
      elements.style.backgroundColor="#6153cc";
      color=false;
    }
};
        window.addEventListener('scroll', onScroll, {
    passive: true
});
      }
      if(this.$route.query.buy != null)
      {
        this.isModalVisible = true;
      }
      if(this.$route.query.trackId != null)
          {
            if(this.$route.query.status != 2)
            {
                this.isModalVisible = true;
                this.kharid = 1;
                this.kharidText='لطفا با پشتیبانی تماس بگیرید\n کد تراکنش: \n'+this.$route.query.orderId;
            }
            else
            {
            axios.get(`https://api3.roboo.ir/api/Payment/VerifyPayment?TransId=`+this.$route.query.trackId)
          .then(response => {
              if(response.data == 1)
              {
               this.isModalVisible = true;
                this.getuserData();
              }
          });
            }
          }

          if(localStorage.getItem("firsttime") == 'true')
          {
            this.isFirstTime = true;
            if(localStorage.getItem("googleAccount") != null)
            {
              this.isGoogleAccount = true;
            }
            localStorage.setItem("firsttime",'false');
          }
        if(localStorage.getItem("userName") != null)
        this.name = localStorage.getItem("userName");
        this.getuserData();
        this.categorys(0);
        setTimeout(()=>{
          if(that.$route.path == "/")
          {
            if(that.isModalFirstTime == false && that.showNameDialog == false && that.isModalVisible == false && that.isModalUpdate == false)
            {
             // if(localStorage.getItem("showInstagram") == null)
              that.isModalInstagram = true;
            }
          }
      },3000)
    }
}
</script>
<style lang="scss" scoped>
 #app-menu
  {
    margin-top: 55px;
  }
.login-box {
  top: 50%;
        left: 50%;
        position: fixed;
  width: 90vw;
  padding: 10px;
  transform: translate(-50%, -50%);
z-index: 10000;
  background-color:rgb(24, 24, 24);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0,0,0,.6);
  border-radius: 10px;

}
.custom
{
  filter:blur(5px);
}

.purchaseSuccess {
        border: 1px solid #0abf81
    }
    
    .purchaseSuccess .title {
        color: #0abf81;
    }
    
    .purchaseSuccess .text {
        line-height: 22px;
    }
    
    .purchaseFail .text {
        line-height: 22px;
    }
    
    .purchaseAlert .text {
        line-height: 22px;
    }
    
    .purchaseSuccess 
    .fa-thumbs-up {
        color: #0abf81;
        border: 1px solid #0abf81;
        top: -15px;
        left: 20px;
    }
    
    .nameSuccess {
        border: 1px solid #6153cc
    }
    
    .nameSuccess .title {
        color: #6153cc;
    }
    
    .nameSuccess .text {
        line-height: 22px;
    }
    
    
    .nameSuccess 
    .fa-thumbs-up {
        color: #6153cc;
        border: 1px solid #6153cc;
        top: -15px;
        left: 20px;
    } 
    .purchaseFail {
        border: 1px solid #ff0048
    }
    
    .purchaseFail .title {
        color: #ff0048;
    }
    
@font-face {
        font-family: IRANSansWeb;
        src: url('../assets/IRANSansWeb.woff2') format("woff2");
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: IRANSansWeb;
        src: url('../assets/IRANSansWebBold.woff2') format("woff2");
        font-weight: bold;
        font-style: normal;
    }
    span {
  font-family: IRANSansWeb;
  font-weight: bold;
}
@function gray($color){
  @return rgb($color, $color, $color);
}

$red: rgb(239, 83, 80);
$orange: rgb(255, 160, 0);
$yellow: rgb(253, 216, 53);
$green: rgb(42, 252, 152);
$indigo: rgb(57, 73, 171);
$violet: rgb(103, 58, 183);

/* -- */

$blue: rgb(66, 165, 245);

@keyframes blink {
  from, 25%, to {
    opacity: 1;
  }
  
  50% {
    opacity: 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(720deg);
  }

  to {
    transform: rotate(1440deg);
  }
}

@keyframes bounce {
  from, 6.66%, 17.66%, 33.33% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  13.33%, 14.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  23.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  26.66% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  30% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}

body{
  margin: 0px;
  overflow-x: hidden;
  padding: 0px;
  
  &::-webkit-scrollbar-track {
    background-color: gray(30);
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(white, 0.2);
    border-radius: 100px;
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  input, h1, h3, a, span {
    color: gray(90);
    font-family:IRANSansWeb;
    font-weight: bold;
    font-weight: 400;
    margin: 0px;
    padding: 0px;
  }
}

$backgroundImage: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2076&q=80";

.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.clear-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.1);
  border-radius: 100px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;
  
  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}
.text-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;
  
  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}
.text-button2 {
  background-color: rgba(white, 0.1);
}
#app {
  background-color: gray(30);
  
  &.logged-out {
    #app-info {
      margin-left: 40px;
      opacity: 1;
      transform: translateX(0%);
    }
    
    #app-background {
      cursor: pointer;
    }
    
    #sign-in-button-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -40px); 
    }
  }
  
  &.logging-in,
  &.verifying-log-in,
  &.log-in-error {
    #app-background {
      #app-background-image {
        filter: blur(8px);
        transform: scale(1.2);
      }
    }
  }
  
  &.logging-in,
  &.log-in-error {
    #app-pin-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -50%) scale(1);
    }
  }
  
  &.verifying-log-in {
    #app-loading-icon {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }
  
  &.log-in-error {
    #app-pin-wrapper {
      #app-pin {
        .app-pin-digit {
          background-color: rgba($red, 0.05);
          border-color: rgba($red, 0.5); 
        }      
      }
    }
  }
  
  &.logged-in {
    #app-menu {
      opacity: 1;
      pointer-events: all;
    }
  }
  
  .scrollable-component {
    cursor: grab;
    overflow: auto;
    user-select: none;
    width: 100%;
    
    &:active {
      cursor: grabbing;
    }
    
    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }
  
  #app-loading-icon {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, 0%);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    
    i {
      animation: 2s spin ease-in-out infinite;
      color: white;
      font-size: 2em;
    }
  }
  
  #app-background {
    height: 100%;
    left: 0px;
    overflow: hidden;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 1;
    
    #app-background-image {
      height: 100%;
      transition: filter 250ms, transform 250ms;
      width: 100%;
    }
  }
  
  #app-info {
    bottom: 0px;
    left: 0px;
    margin: 40px;
    margin-left: 0px;
    opacity: 0;
    position: absolute;
    transform: translateX(-100%);
    transition: margin 250ms, opacity 250ms, transform 250ms;
    z-index: 2;
  }
  
  .user-status-button {
    cursor: pointer;
    margin-top: 10px;
    outline: none;
    padding: 10px;
    width: 100px;
    
    i {
      color: gray(245);
      font-size: 1.25em;
    }
  }
  
  #sign-in-button-wrapper {
    bottom: 0px;
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%, 40px);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    
    #sign-in-button {
      &:not(:hover) {
        animation: bounce 3s infinite;
        animation-delay: 3s;
      }
    }
  }
  
  .info {
    align-items: flex-end;
    display: flex;
    
    .time {
      color: gray(245);
      font-size: 6em;
      height: 80px;
      line-height: 80px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
    }
    
    .weather {
      display: inline-flex;
      height: 20px;
      margin-bottom: 6px;
      margin-left: 20px;
      
      i, span {
        align-items: center;
        display: inline-flex;
      }
      
      i {
        color: $yellow;
        font-size: 0.9em;
      }
      
      span {
        color: white;
      }
      
      .weather-type {
        height: 20px;
      }
      
      .weather-temperature-value {        
        font-size: 1.5em;
        height: 20px;
        margin-left: 5px;
      }
      
      .weather-temperature-unit {
        align-items: flex-start;
        font-size: 0.8em;
        margin-left: 3px;
      }
    }
  }
  
  .reminder {
    display: flex;    
    gap: 6px;
    margin-top: 10px;
    
    i, div {
      display: inline-flex;     
    }
    
    i {
      color: gray(245);
      font-size: 0.8em;
      height: 12px;
      line-height: 12px;
    }
    
    span {
      color: rgba(white, 0.8);
      font-size: 1.1em;
    }
    
    .reminder-icon {
      align-items: center;
      height: 20px;
    }
    
    .reminder-time {
      align-items: flex-end;
      color: gray(30);
      font-size: 0.8em;
      height: 20px;
    }
  }
  
  #quick-nav {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 5px;
    width: 100%;
    z-index: 3;
    
    .quick-nav-item {
      padding: 10px 20px;
      
      &:last-of-type {
        margin-right: 10px;
      }
      
      .quick-nav-item-label {
        color: gray(245);
        text-shadow: 0px 0px 2px rgba(black, 0.1);
      }
    }
  }
  
  #youtube-link {
    align-items: center;
    display: inline-flex;
    gap: 5px;
    margin-top: 10px;
    padding: 10px 20px;
    text-decoration: none;
    
    i, span {
      height: 20px;
      line-height: 20px;
    }
    
    i {
      color: $red;
    }
    
    span {
      color: white;
    }
  }
  
  .menu-section {
    margin-top: 40px;
    
    .menu-section-title {
      align-items: center;
      display: flex;
      gap: 6px;
      
      i, span {
        color: gray(245);
      }
      
      i {
        font-size: 1em;
      }
      
      .menu-section-title-text {
        color: rgba(white, 0.9);
        font-size: 1.4em;
        font-weight:bold;
      } 
    }
    
    .menu-section-content {
      margin-top: 15px;      
      padding-top: 5px;
    }
  }
  
  #restaurants-section { 
    .menu-section-content {
      display: flex;
      gap: 1em;
      
      .restaurant-card {
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 14vw;
        max-height: 240px;
        position: relative;
        transition: transform 250ms;
        width: 25%;
        
        &:hover {
          transform: translateY(-5px);
          
          .restaurant-card-content {            
            .restaurant-card-content-items {
              margin-bottom: 30px;   
            }
          }
        }
        
        .restaurant-card-content {
          background: linear-gradient(to top, rgba(black, 0.8), transparent);
          border-radius: 10px;
          height: 100%;
          width: 100%;
          
          .restaurant-card-content-items {
            bottom: 0px;
            display: flex;
            flex-direction: column;
            margin: 20px;
            position: absolute;
            right: 0px;
            text-align: right;
            transition: margin 250ms;
            
            .restaurant-card-title {
              color: gray(245);
              font-size: 1.5em;
            }

            .restaurant-card-desc {
              color: $blue;
              font-size: 0.9em;
            }
          }
        }
      }
    }
  }
  
  #weather-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      padding: 5px 0px;
      width: 100%;      

      .day-card {
        backdrop-filter: blur(3px);
        background-color: rgba(white, 0.1);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        height: 8vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 180px;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 7);
        
        &:last-of-type {
          margin-right: 5px;
        }

        .day-card-content {
          display: flex;
          flex-direction: column;
          height: calc(100% - 20px);
          justify-content: space-evenly;
          padding: 10px;

          i, span {
            color: gray(245);
            text-align: center;
          }

          .day-weather-temperature {
            align-items: flex-start;
            display: flex;
            font-size: 0.9em;
            justify-content: center;

            .day-weather-temperature-unit {
              font-size: 0.8em;
              margin-left: 3px;
            }
          }

          .day-weather-icon {
            font-size: 3.5em;
            text-shadow: 2px 2px 2px rgba(black, 0.1);

            &.sunny {
              color: $yellow;
            }

            &.rainy,
            &.stormy {
              color: $blue;
            }
          }

          .day-name {
            font-size: 0.9em;
            text-transform: uppercase;
          }
        }
      }
    }
  }
  
  #tools-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      width: 100%;      
        height:50vh;
      .tool-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 160px;

        position: relative;
        transition: transform 250ms;
        width: calc(100% / 6);
        
        &:hover {
          transform: translateY(-5px);
        }
        
        .tool-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: filter 250ms;
          width: 100%;
        }
        
        .tool-card-content {
          display: flex;

          i, span {
            color: gray(245);
          position: absolute;
       width:100%;
       height:60%;

            }
          
          .tool-card-content-header {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .tool-card-label {
              color: $blue;
              font-size: 0.8em;
              text-transform: uppercase;
            }

            .tool-card-name {
              color: white;
              text-align: center;
              bottom:0;
              font-weight:bold;
              font-size: 1.5em;
            }
          }

          .tool-card-icon {
            color: gray(245);
            font-size: 2em;
          }
        }
      }
    }
  }
  
  #movies-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      
      #movie-card-1 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($indigo, 0.4), transparent, rgba(black, 0.4));
        }
      }
        
      #movie-card-2 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($violet, 0.4), transparent, rgba(black, 0.4));
        }
      }
        
      #movie-card-3 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($red, 0.4), transparent, rgba(black, 0.4));
        }
      }
        
      #movie-card-4 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($green, 0.4), rgba(black, 0.1), rgba(black, 0.4));
        }
      }
        
      .movie-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 40vw;
        max-height: 600px;
        min-height: 460px;
        min-width: 260px;
        overflow: hidden;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 4);
        
        &:hover {
          transform: translateY(-5px);
          
          .movie-card-background {
            transform: scale(1.05);
          }
          
          .movie-card-content {
            i {
              transform: translate(-20%, -20%) scale(1.2);
            } 
          }
        }
        
        .movie-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: transform 250ms;
          width: 100%;
          z-index: 1;
        }
        
        .movie-card-content {
          background: linear-gradient(to top, rgba(black, 0.5), rgba(black, 0.1), rgba(black, 0.4));
          border-radius: 10px;
          height: 100%;
          position: relative;
          z-index: 2;
          
          .movie-card-info {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 30px;
            
            span {              
              text-shadow: 2px 2px 2px rgba(black, 0.1);
            }
            
            .movie-card-title {
              color: gray(245);
              font-size: 1.5em;
              font-weight:bold;
            }
            
            .movie-card-desc {
              color: gray(200);
              font-size: 0.9em;
            }            
          }
          
          i {
            bottom: 0px;
            color: gray(245);
            font-size: 5em;
            padding: 30px;
            position: absolute;
            right: 0px;
            text-shadow: 2px 2px 2px rgba(black, 0.1);
            transition: transform 250ms;
          }
        }
      }
    }
  }
  
  #app-pin-wrapper {
    left: 50%;
    opacity: 0;        
    pointer-events: none;
    position: absolute;
    top: 50%;    
    transform: translate(-50%, -30%) scale(0.8);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    
    #app-pin-label {
      color: gray(245);
      font-size: 0.9em;
      margin: 10px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
      
      #app-pin-cancel-text {
        cursor: pointer;
        margin-left: 2px;
        
        &:hover {
          text-decoration: underline;
        }
      }
      
      #app-pin-error-text {
        color: $red;
      }
    }
    
    #app-pin-hidden-input {
      background-color: transparent;
      border: none;
      height: 0px;
      outline: none;
      pointer-events: none;
      position: absolute;
      width: 0px;
    }
    
    #app-pin {
      display: flex;
      gap: 10px;
      
      .app-pin-digit {
        align-items: center;
        background-color: rgba(white, 0.05);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 2px rgba(black, 0.06);
        display: inline-flex;
        font-size: 3em;
        height: 80px;
        justify-content: center;
        position: relative;
        transition: background-color 250ms, border-color 250ms;
        width: 60px;
        
        &:after,
        &:before {
          box-shadow: 2px 2px 2px rgba(black, 0.06);
          content: "";
          position: absolute;
          transition: opacity 250ms, transform 250ms;
          z-index: 2;
        }
        
        &:before {
          background-color: gray(245);
          border-radius: 10px;
          bottom: 0px;
          height: 3px;
          left: 15%;
          opacity: 0;
          transform: translateY(0px);
          width: 70%;
        }
        
        &:after {
          background-color: gray(245);
          border-radius: 20px;
          height: 20px;
          opacity: 0;
          transform: scale(0.25);
          width: 20px;
        }
        &.focused {
          &:before {
            animation: blink 2s ease-in-out infinite;
            opacity: 1;
            transform: translateY(-10px);
          }
        }
        
        &.hidden {
          &:after {
            opacity: 1;
            transform: scale(1);
          }
          
          .app-pin-digit-value {
            opacity: 0;
            transform: scale(0.25);
          }
        }
        
        .app-pin-digit-value {
          color: gray(245);
          transition: opacity 250ms, transform 250ms;
        }
      }
    }
  }
  
  #app-menu {
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    position: relative;
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    
    #app-menu-content-wrapper {
      background: #212529;
      min-height: 80vh;
      padding: 80px;
      padding-top: 0px;
      
      #app-menu-content {
        margin: auto;
        max-width: 1600px;
        position: relative;
        
        #app-menu-content-header {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}

@media(max-width: 1300px) {
  #app {
    &.logged-out {
      #sign-in-button-wrapper {
        transform: translate(-40px, 0px); 
      }
    }
  
    #sign-in-button-wrapper {
      bottom: 40px;
      left: auto;
      right: 0px;
      transform: translate(40px, 0px); 
    }
    
    #app-menu {
      #app-menu-content-wrapper {
        padding: 20px;
        
        #app-menu-content {
          #restaurants-section { 
            .menu-section-content {
              flex-wrap: wrap;

              .restaurant-card {
                height: 22vh;;
                max-height: 300px;
                position: relative;
                width: calc(50% - 0.5em);
              }
            }
          }
          
          #tools-section {
            .menu-section-content {
              
              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 600px) {
  #app {
    .info {
      .time {
        font-size: 4em;
        height: 60px;
        line-height: 60px;
      }
    }
    
    .user-status-button {
      width: 60px;
    }
  
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {  
          #restaurants-section { 
            .menu-section-content {
              flex-direction: column;

              .restaurant-card {
                height: 40vw;
                position: relative;
                width: 100%;
              }
            }
          }
          
          #tools-section {
            .menu-section-content {
              
              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 400px) {
  #app {
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #tools-section {
            .menu-section-content {
              
              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}
.overflow2 {
  margin: 0 0 2em 0;
  text-overflow: ellipsis;
  width:82vw;
  /**
   * Required properties to achieve text-overflow
   */
    white-space: nowrap;
    overflow: hidden;
}
.overflow {
  margin: 0 0 2em 0;
  text-overflow: ellipsis;
  /**
   * Required properties to achieve text-overflow
   */
    white-space: nowrap;
    overflow: hidden;
}
</style>